// libraries/frameworks
import axios from 'axios';

export const getLessonPlanOptionsFileType = async () => {
  const result = await axios.get(process.env.REACT_APP_REACT_API_LESSEON_PLAN_OPTIONS_FILE_TYPE);
  return result;
};
